import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import debounce from 'lodash/debounce';
import { VIDEO_SIZES } from '~/const/images';
import { SLOW_TIMER } from '~/const/timers';
export default {
  props: {
    loop: {
      type: Boolean,
      default: true
    },
    muted: {
      type: Boolean,
      default: true
    },
    autoPlay: {
      type: Boolean,
      default: true
    },
    webkitPlaysinline: {
      type: Boolean,
      default: true
    },
    playsinline: {
      type: Boolean,
      default: true
    },
    videos: {
      type: Object,
      default: function _default() {}
    },
    videoImages: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      widthWindow: null,
      selectedVideo: '',
      selectedImage: ''
    };
  },
  mounted: function mounted() {
    this.initVideoUrl();
    window.addEventListener('resize', debounce(this.initVideoUrl, SLOW_TIMER));
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.initVideoUrl);
  },
  methods: {
    initVideoUrl: function initVideoUrl() {
      var _this = this;

      this.widthWindow = window.innerWidth;
      var sizeValues = Object.values(VIDEO_SIZES);
      var indexSize = sizeValues.findIndex(function (size) {
        return _this.widthWindow <= size;
      });
      indexSize = indexSize !== -1 ? indexSize : sizeValues.length - 1;
      this.selectedVideo = this.videos[Object.keys(VIDEO_SIZES)[indexSize]];
      this.selectedImage = this.videoImages[Object.keys(VIDEO_SIZES)[indexSize]];
    }
  }
};